module.exports = __webpack_public_path__ + "img/avatar.1e976c46.png";